var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"cursor-pointer",on:{"click":_vm.onTriggerClick}},[_c('custom-icon',{attrs:{"icon":_vm.innerValue || 'patch-question'}})],1),_vm._v(" "),(_vm.showSelectIconDialog)?_c('select-icon-dialog',{attrs:{"visible":true,"selected-icon":_vm.innerValue},on:{"selected":_vm.onSelected,"close":_vm.onDialogClose}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1469fa20","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconSelector/index.vue
// module id = 1428
// module chunks = 1